var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stringBuilder, isObject } from '../util';
import { noop } from 'lodash';
const TuxAppliedFilters = (props) => {
    const { items, bind_label = '', className, disabled = false, horizontal = false, onRemove = noop, onItemsChange = noop, readonly = false } = props, rest = __rest(props, ["items", "bind_label", "className", "disabled", "horizontal", "onRemove", "onItemsChange", "readonly"]);
    const handleRemoveItem = (itemToRemove) => {
        const newItems = items.filter((item) => {
            if (isObject(item) && isObject(itemToRemove)) {
                return item[bind_label] !== itemToRemove[bind_label];
            }
            return item !== itemToRemove;
        });
        onRemove(itemToRemove);
        onItemsChange(newItems);
    };
    const classes = stringBuilder('unstyled', { horizontal_list: horizontal }, className);
    const filterClasses = stringBuilder('applied_filter', { disabled, readonly });
    return (_jsx("ul", Object.assign({}, rest, { className: classes }, { children: items.map((item, i) => (_jsx("li", { children: _jsxs("span", Object.assign({ className: filterClasses }, { children: [!disabled && !readonly && (_jsx("button", { "aria-label": `remove ${isObject(item) ? item[bind_label] : item}`, className: "close", onClick: () => handleRemoveItem(item), type: "button" }, void 0)), isObject(item) ? item[bind_label] : item] }), void 0) }, i))) }), void 0));
};
export default TuxAppliedFilters;
